import React, { useEffect } from 'react'
import Close from 'SVGPath/close.svg'

const SlideModal = ({
  header,
  onCloseClick,
  subHeader,
  headerType = 'normal',
  children,
  open,
  subHeaderClass = '',
  bodyClass = '',
  addAlertOverlayClass = '',
  caseToggle = false,
  fullContent,
  refundToggle = false,
  baggageToggle = false
}) => {
  useEffect(() => {
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0] && open) {
      ele[0].classList.add('overflow-hidden')
    } else if (ele && ele[0] && caseToggle) {
      return () => {
        ele[0].classList.remove('overflow-hidden')
        window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' })
      }
    }
  }, [fullContent])

  useEffect(() => {
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0] && (refundToggle || baggageToggle)) {
      ele[0].classList.remove('overflow-hidden')
    }
  }, [refundToggle, baggageToggle])
  return (
    <If condition={open}>
      <section className={`backdrop ${headerType === 'page' ? 'top-50 bottom-34 ' : ''} `}>
        <div
          className={`${
            headerType === 'normal' ? 'backdrop--modal' : 'backdrop--modal h-100p bg-base'
          } ${addAlertOverlayClass}`}
        >
          <div className="flex flex-between flex-center flex-column border-bottom-grey">
            <If condition={headerType === 'normal'}>
              <div className="backdrop--header flex flex-between p-4 flex-1 flex-middle">
                <div className="flex flex-column flex-center">
                  <p className="fs-15 c-white tt-sentence">{header}</p>
                  <If condition={subHeader}>
                    <p className={`fs-11 pt-001 ${subHeaderClass}`}>{subHeader}</p>
                  </If>
                </div>
                <Close onClick={onCloseClick} className="arrow-min ml-1" fill="#fff" />
              </div>
              <Else />
              <div className="flex flex-1 flex-start">
                <div
                  className="c-blue px-4 py-3 br bc-neutral-200 fs-heading cursorPoi"
                  onClick={onCloseClick}
                >
                  &larr;
                </div>
                <div className="flex px-4 py-3 flex-center flex-column flex-1">
                  <p className="fs-15 tt-sentence fw-600">{header}</p>
                  <If condition={subHeader}>
                    <p
                      className={`fs-11 ${
                        subHeaderClass ? 'tt-first-caps' : 'tt-sentence'
                      } color-8a pt-1`}
                    >
                      {subHeader}
                    </p>
                  </If>
                </div>
              </div>
            </If>
          </div>
          <div className={`slide-modal__body ${bodyClass}`}>{children}</div>
        </div>
      </section>
    </If>
  )
}

export default SlideModal
